import { IAIAnalyzeClass } from './i-ai-analyze-class';

export class AIJobRequest {
  constructor(
    public job_id: string,
    public url: string,
    public analysis_types: IAIAnalyzeClass[],
  ) {}
}
